/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   Spanish counterpart for each blog.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal singular "tú".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.es = window.TD_I18N.es || {};
  Object.assign(window.TD_I18N.es, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sobre el Dr. Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Notas desde el<br><em>laboratorio.</em>',
    'blog.intro': 'La ciencia, los sérums y los rituales de cuidado de la piel de Transderma: treinta años de investigación, traducidos para el estante del baño.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Todos',
    'blog.filter.science': 'Ciencia',
    'blog.filter.ingredients': 'Ingredientes',
    'blog.filter.routines': 'Rutinas',
    'blog.filter.longevity': 'Longevidad',

    /* ── Shared "Read" link ── */
    'blog.read': 'Leer <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'Próximamente',
    'blog.notice.upcoming': 'Los artículos se publicarán pronto · suscríbete abajo para recibir aviso',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Ciencia',
    'blog.a1.time': '7 min de lectura',
    'blog.a1.date': 'Abr 2026',
    'blog.a1.title': 'Por qué el cuidado de la piel <em>sin agua</em> sí funciona, y por qué la mayoría de los sérums no.',
    'blog.a1.excerpt': 'Entre el sesenta y el noventa por ciento del contenido de un frasco medio de sérum es agua. El resto son emulsionantes, espesantes y conservantes. Cuando decimos que Transderma es sin agua, queremos decir que cada gota es fórmula activa. Aquí está la química detrás de esa elección, y por qué cambia cuánto llega realmente a la piel.',
    'blog.a1.read': 'Leer el artículo <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Ingredientes',
    'blog.a2.time': '5 min',
    'blog.a2.title': 'Palmitato de retinilo frente a retinol: una vía más suave hacia la renovación.',
    'blog.a2.excerpt': 'Por qué Serum A utiliza el éster palmitato de la vitamina A: cómo se convierte dentro de la piel, por qué se estabiliza con vitamina E y a quién le conviene más.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Ciencia',
    'blog.a3.time': '6 min',
    'blog.a3.title': 'La administración transdérmica, explicada para el estante del baño.',
    'blog.a3.excerpt': 'Qué significa realmente "más allá del estrato córneo", cómo el escualano transporta vitaminas activas a través de la capa externa de la piel, y la investigación de profundidad detrás del nombre.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Rutinas',
    'blog.a4.time': '4 min',
    'blog.a4.title': 'Construye una rutina Transderma en cinco pasos.',
    'blog.a4.excerpt': 'Mañana, noche, orden de aplicación y cómo añadir Serum M sin diluir el activo de debajo. El ritmo que convierte cinco frascos en un sistema.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Longevidad',
    'blog.a5.time': '8 min',
    'blog.a5.title': 'La cuestión mitocondrial: por qué Serum O es el sérum de la longevidad.',
    'blog.a5.excerpt': 'PQQ, creatina, vitaminas B. El argumento para tratar el envejecimiento de la piel a nivel de la energía celular, y por qué el apoyo mitocondrial está en el centro de la fórmula más distintiva de la línea.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Ingredientes',
    'blog.a6.time': '5 min',
    'blog.a6.title': 'Resveratrol, piceido y la ciencia detrás de las marcas posacné.',
    'blog.a6.excerpt': 'Cómo cuatro ingredientes (y nada de agua) abordan el tono irregular, el daño ambiental y las marcas que permanecen mucho después de que el grano haya desaparecido.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Ciencia',
    'blog.a7.time': '6 min',
    'blog.a7.title': 'Ceramidas, colesterol y el mortero lipídico de la piel.',
    'blog.a7.excerpt': 'Por qué una barrera que retiene su propia hidratación es el objetivo, y cómo Serum M complementa los lípidos que tu piel ya sabe fabricar.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Rutinas',
    'blog.a8.time': '3 min',
    'blog.a8.title': 'Dos gotas bastan. El argumento contra el exceso de aplicación.',
    'blog.a8.excerpt': 'Un sérum concentrado sin agua no se comporta como una crema hidratante con un 65 % de agua. Por qué menos material llega más lejos cuando la fórmula trabaja con tu piel, no contra ella.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Mensual',
    'blog.news.title': 'Una carta breve <em>cada mes.</em>',
    'blog.news.body': 'Nuevos artículos, novedades discretas sobre productos y, de vez en cuando, una palabra desde el laboratorio. Sin promociones, sin relleno. Una nota pensada y un enlace para darte de baja en cada correo.',
    'blog.news.placeholder': 'tu@email.com',
    'blog.news.aria': 'Correo electrónico',
    'blog.news.button': 'Suscribirse'

  });
})();
